import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import AccessControl from '../components/AccessControl';
import { Session } from '../contexts/sessionContext';
import NotAccessible from '../components/NotAccessible';
import axios from 'axios';
import { checkPermissions } from '../helpers/utils';

interface PermissionRouteProps {
  component?: React.ComponentType;
  render?: () => React.ReactNode;
  allowedPermissions?: any;
  noAccess?: React.ReactNode;
}

const PermissionRoute = ({
  component: Component,
  render,
  allowedPermissions = [],
  noAccess = <NotAccessible text="You are not permitted to view this page." />,
}: PermissionRouteProps) => {
  const {
    state: {
      user: { permissions },
    },
  } = useContext(Session);

  const { pathname } = useLocation();

  useEffect(() => {
    if (checkPermissions(permissions, allowedPermissions)) {
      // don't await.
      axios.post('/stats', { trackerPath: pathname });
    }
  }, [pathname, permissions, allowedPermissions]);

  return (
    <AccessControl
      userPermissions={permissions}
      allowedPermissions={allowedPermissions}
      noAccess={noAccess}
    >
      {Component ? <Component /> : render ? render() : null}
    </AccessControl>
  );
};

export default PermissionRoute;
